module.exports = __webpack_public_path__ + "root-b33b72b3/XING-Sans-Medium-78d60f26facae4864eb6b20c6bfa7909.woff";